import { SignUp } from "@clerk/clerk-react";
import { sharedStyles } from '../styles/sharedStyles';

const SignUpPage = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: sharedStyles.colors.background.default,
      padding: '1rem'
    }}>
      <SignUp 
        appearance={{
          elements: {
            rootBox: {
              width: '100%',
              maxWidth: '480px'
            },
            card: {
              backgroundColor: 'white',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
              borderRadius: '0.5rem'
            }
          }
        }}
      />
    </div>
  );
};

export default SignUpPage; 